import { withAnalyticsTracking } from '../../../utils/withAnalyticsTracking'
import { StaticActionHandler } from '../actionHandlers'
import { TransactionsSalesTaxReturnsActionType } from '../utils/getSalesTaxReturnsActions'

export const salesTaxReturnsActionHandlers: Record<TransactionsSalesTaxReturnsActionType, StaticActionHandler> = {
  [TransactionsSalesTaxReturnsActionType.VoidPayment]: withAnalyticsTracking(
    ({ openModal, voidVatDeclarationPaymentModalId }) => {
      openModal(voidVatDeclarationPaymentModalId)
    },
    'Sales Tax Returns',
    TransactionsSalesTaxReturnsActionType.VoidPayment,
  ),

  [TransactionsSalesTaxReturnsActionType.VoidSettlement]: withAnalyticsTracking(
    ({ openModal, voidVatDeclarationModalId }) => {
      openModal(voidVatDeclarationModalId)
    },
    'Sales Tax Returns',
    TransactionsSalesTaxReturnsActionType.VoidSettlement,
  ),
}
